import { cn } from '@/lib/utils'
import { Target, TrendingUp, Plane, Building2, Key } from 'lucide-react'

const features = [
  {
    icon: Target,
    title: 'Método Validado',
    description:
      'O passo a passo exato usado para escalar agências do zero aos múltiplos 6 dígitos.',
  },
  {
    icon: TrendingUp,
    title: 'Faturamento em Dólar',
    description:
      'Ganhe 5x mais convertendo seu esforço em moeda forte, blindando seu patrimônio.',
  },
  {
    icon: Plane,
    title: 'Liberdade Geográfica',
    description:
      'Trabalhe de onde quiser. Tudo que você precisa é um notebook e internet.',
  },
  {
    icon: Building2,
    title: 'Negócio Sólido',
    description:
      'Construa um império real, não apenas uma renda extra passageira.',
  },
  {
    icon: Key,
    title: 'Acesso Exclusivo',
    description:
      'Network com a elite do mercado. Você é a média das pessoas com quem convive.',
  },
]

export const FeaturesSection = () => {
  return (
    <section className="bg-black py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-heading font-black text-center text-white mb-12 md:mb-20 leading-tight uppercase max-w-5xl mx-auto text-balance">
          Pare de sonhar. Comece a viver.
          <br className="hidden md:block" />
          <span className="text-primary mt-2 block text-xl sm:text-2xl md:text-5xl lg:text-6xl">
            Isso é o que você vai ter:
          </span>
        </h2>

        <div className="grid gap-4 md:gap-6 max-w-4xl mx-auto">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-[#111] rounded-xl md:rounded-2xl p-6 md:p-10 border-l-4 border-primary flex flex-col md:flex-row items-start md:items-center gap-5 md:gap-8 hover:bg-[#1A1A1A] transition-colors duration-300 group shadow-lg"
            >
              <div className="shrink-0 p-4 md:p-5 rounded-full bg-primary/10 group-hover:bg-primary/20 transition-colors duration-300">
                <feature.icon
                  className="w-8 h-8 md:w-12 md:h-12 text-primary group-hover:scale-110 transition-transform duration-300"
                  strokeWidth={1.5}
                />
              </div>
              <div className="text-left flex-1">
                <h3 className="font-heading font-bold text-xl md:text-2xl text-white mb-2 md:mb-3 uppercase tracking-wide">
                  {feature.title}
                </h3>
                <p className="font-sans text-base md:text-lg text-gray-400 font-normal leading-relaxed text-balance">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
